<template>
    <article class="llmBlock" :class="params.class">
        <h3 v-if="title">{{title}}</h3>
        <div class="inlineBlock">
            <div>
                <label>Сеть</label>
                <el-select v-model="llm.llm" @change="llm => handleSelectLlm(llm, true)"
                           @clear="handleClearSelect"
                           value-key="id"
                           style="width: 375px">

                    <el-option v-for="llm in list"
                               :value="llm"
                               :label="llm.name"
                               :key="llm.id">
                    </el-option>
                </el-select>
            </div>
            <div>
                <label>Шаблон LLM</label>
                <el-select v-model="llm.id"
                           style="width: 275px"
                >
                    <el-option v-for="tpl in opts.templates"
                               :value="tpl.id"
                               :label="tpl.alias"
                               :key="tpl.id">
                    </el-option>
                </el-select>
            </div>
        </div>
    </article>
</template>

<script>
    import {mapState} from "vuex";

    export default {
        name: "LlmBlock",
        props: {
            llm: {
                type: Object,
                default: () => ({
                    "llm": "",
                    "template": "",
                })
            },
            params: {
                type: Object,
                default: () => ({})
            },
            title: ''
        },
        data() {
            return {
                opts: {
                    inputs: ["input", "prompt", "query", "request"],
                    docs: ["docs", "documents", "texts", "doc", "document", "text"],
                    templates: []
                },

            }
        },
        computed: {
            ...mapState('llm', ['list']),
        },
        mounted() {
            this.handleSelectLlm(this.llm.llm);
        },
        watch: {
            llm(newLlm) {
                this.handleSelectLlm(newLlm.llm);
            },
        },
        methods: {
            handleSelectLlm(llm, change=false) {
                let _llm = this.list.find(it => it.id === llm.id);
                // console.log('handleSelectedLlm', _llm, alias);
                if (_llm) {
                    this.opts.templates = _llm.templates
                    this.llm.id = (change ? null : this.llm?.id ) || _llm.templates[0]?.id || ''
                }
            },
            handleClearSelect() {
                this.llm.template = ''
            }
        }

    }
</script>

<style scoped lang="scss">

    .inlineBlock {
        display: flex;
        gap: 20px;
    }

    label {
        display: inline-block;
        margin-right: 7px;
    }

</style>
